import type { DefinedRoutePattern } from './definedRoutePatterns'

/**
 * Named path constants shared by the router and primary navigation.
 * Nav/search hrefs must use these (or known-missing allowlist entries).
 */
export const paths = {
  root: '/',
  dashboard: '/dashboard',
  listings: '/listings',
  listingsNew: '/listings/new',
  inbox: '/inbox',
  contacts: '/contacts',
  opportunities: '/opportunities',
  tasks: '/tasks',
  journeys: '/journeys',
  journeysNew: '/journeys/new',
  analyticsCrm: '/analytics/crm',
  agentReviews: '/agent/reviews',
  plans: '/plans',
  settings: '/settings',
  settingsTenants: '/settings/tenants',
  agency: '/agency',
  agencyReports: '/agency/reports',
  agencyRouting: '/agency/routing',
  agencySettings: '/agency/settings',
  agencySettingsRoles: '/agency/settings/roles',
  agencySettingsAudit: '/agency/settings/audit',
  agencyCredits: '/agency/credits',
  adminPackages: '/admin/packages',
  adminFin: '/admin/fin',
  adminFinOverview: '/admin/fin/overview',
  adminFinReconciliation: '/admin/fin/reconciliation',
  adminFinDunning: '/admin/fin/dunning',
  adminScoring: '/admin/scoring',
  adminScoringAiConfigs: '/admin/scoring/ai-configs',
  adminPortals: '/admin/portals',
  adminMarkets: '/admin/markets',
  adminStrategyConfig: '/admin/strategy/config',
  adminCommentClassifier: '/admin/comment-classifier',
  adminAudit: '/admin/audit',
  adminValuationPriceReports: '/admin/valuation/price-reports',
} as const

export type NavPath = (typeof paths)[keyof typeof paths]

/**
 * Type-checked helper so App.tsx Route `path` props consume the catalog.
 */
export function rp<P extends DefinedRoutePattern>(path: P): P {
  return path
}
